import { reportEvent } from './util';

const ERROR_CODE_KEY = 'wetv_linux_errorcodes';
const MAX_ERROR_CODES = 3;

export function getErrorCodes() {
  const errorCodes = localStorage.getItem(ERROR_CODE_KEY) || '';
  return errorCodes;
}

export function setErrorCode(errorCode) {
  if (!errorCode) {
    return;
  }
  const existingErrorCodes = localStorage.getItem(ERROR_CODE_KEY);
  const errorCodesArray = existingErrorCodes ? existingErrorCodes.split('|') : [];

  if (errorCodesArray.length >= MAX_ERROR_CODES) {
    errorCodesArray.shift(); // 移除最早的错误码
  }
  errorCodesArray.push(errorCode); // 将新的错误码添加到末尾

  try {
    localStorage.setItem(ERROR_CODE_KEY, errorCodesArray.join('|'));
  } catch (error) {
    console.error('Failed to access localStorage:', error);
    reportEvent({
      name: 'localStorageError',
      ext2: {
        errCode: 'errorCode set local storage error',
        msg: 'Failed to access localStorage',
        error: error.message,
      },
    });
  }
}

export function clearErrorCodes() {
  localStorage.removeItem(ERROR_CODE_KEY);
}


